import { compactSelectStyles, inputStyle, labelStyle, MultiSelectInput, RangeInput } from "./utils"
import { cities } from "../notifications/AddNotification"
import Select from 'react-select';
import { useGetMunicipalitiesQuery } from "../../store/services/municipalitiesServices";

/* SEF = scanned fiscal QR code, PEF = entered manually, non_fiscal = non-fiscal receipt */
const RECEIPT_TYPE_OPTIONS = [
    { value: "", label: "Të gjitha" },
    { value: "SEF", label: "SEF" },
    { value: "PEF", label: "PEF" },
    { value: "non_fiscal", label: "Jo fiskal" },
]

export const ReceiptsFilters = ({ multiSelectFilters, handleMultiSelectFiltersChange, multiSelectItems, handleMultiSelectItemsChange, rangeItems, handleRangeItemsChange, dropdownMultiSelectItems, handleDropdownMultiSelectChange, handleDeleteMultiSelectFilters, receiptType = "", handleReceiptTypeChange }) => {

    const { NUIs, coupon_ids, fiscal_device_serial_numbers } = multiSelectItems
    const { start_sum_with_vat, end_sum_with_vat, start_sum_without_vat, end_sum_without_vat } = rangeItems
    const { municipalities_no } = dropdownMultiSelectItems
    const { NUIs: selectedNUIs, coupon_ids: selectedCouponIds, fiscal_device_serial_numbers: selectedFiscalDeviceSerialNumbers } = multiSelectFilters

    const { data: municipalities } = useGetMunicipalitiesQuery()

    return (
        <div className="flex flex-col gap-3">
            <div className="flex flex-col gap-1.5">
                <label htmlFor="receipt_type" className={labelStyle}>Lloji</label>
                <Select
                    inputId="receipt_type"
                    name="type"
                    isSearchable={false}
                    styles={compactSelectStyles}
                    menuPortalTarget={typeof document !== "undefined" ? document.body : null}
                    menuPosition="fixed"
                    options={RECEIPT_TYPE_OPTIONS}
                    value={RECEIPT_TYPE_OPTIONS.find((option) => option.value === receiptType) || RECEIPT_TYPE_OPTIONS[0]}
                    onChange={(option) => handleReceiptTypeChange?.(option?.value || "")}
                />
            </div>
            <MultiSelectInput
                type="number"
                name="NUIs"
                label="NUI"
                placeholder="Kerko sipas NUI"
                value={NUIs}
                handleValueChange={handleMultiSelectItemsChange}
                handleSelectedValuesChange={handleMultiSelectFiltersChange}
                selectedValues={selectedNUIs}
                handleDeleteMultiSelectFilters={handleDeleteMultiSelectFilters}
            />
            <MultiSelectInput
                type="text"
                name="coupon_ids"
                label="Numri i kuponit"
                placeholder="Kerko sipas numrit të kuponit"
                value={coupon_ids}
                handleValueChange={handleMultiSelectItemsChange}
                handleSelectedValuesChange={handleMultiSelectFiltersChange}
                selectedValues={selectedCouponIds}
                handleDeleteMultiSelectFilters={handleDeleteMultiSelectFilters}
            />
            <MultiSelectInput
                type="number"
                name="fiscal_device_serial_numbers"
                label="Numri serik"
                placeholder="Kerko sipas numrit serik"
                value={fiscal_device_serial_numbers}
                handleValueChange={handleMultiSelectItemsChange}
                handleSelectedValuesChange={handleMultiSelectFiltersChange}
                selectedValues={selectedFiscalDeviceSerialNumbers}
                handleDeleteMultiSelectFilters={handleDeleteMultiSelectFilters}
            />
            <RangeInput
                type="number"
                start_name="start_sum_with_vat"
                end_name="end_sum_with_vat"
                label="Shuma totale me TVSH"
                start_placeholder="Nga"
                end_placeholder="Deri"
                start_value={start_sum_with_vat}
                end_value={end_sum_with_vat}
                handleValueChange={handleRangeItemsChange}
            />
            <RangeInput
                type="number"
                start_name="start_sum_without_vat"
                end_name="end_sum_without_vat"
                label="Shuma totale pa TVSH"
                start_placeholder="Nga"
                end_placeholder="Deri"
                start_value={start_sum_without_vat}
                end_value={end_sum_without_vat}
                handleValueChange={handleRangeItemsChange}
            />
            <div className="flex flex-col gap-1.5">
                <label htmlFor="region" className={labelStyle}>Regjioni</label>
                <Select
                    isMulti
                    name="municipalities_no"
                    styles={compactSelectStyles}
                    menuPortalTarget={typeof document !== "undefined" ? document.body : null}
                    menuPosition="fixed"
                    options={municipalities?.data.map(municipality => ({
                        value: municipality.municipality_no,
                        label: municipality.municipality_name
                    }))}
                    placeholder="Të gjitha regjionet"
                    onChange={handleDropdownMultiSelectChange}
                    value={municipalities?.data.filter(municipality => municipalities_no?.includes(municipality.municipality_no)).map(municipality => ({
                        value: municipality.municipality_no,
                        label: municipality.municipality_name
                    }))}
                />
            </div>
        </div>
    )
}